import { useEffect, useState, useCallback } from 'react';
import Switch from '@material-ui/core/Switch';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import './switcher.css';

import ReactApiService from '../../services/reactApiService'

export default function Switcher(props) {

	const afterSave = props.afterSave;

  const [optionName, setOptionName] = useState(false);
	const initChecked = props.checked || false;
  const [checked, setChecked] = useState(initChecked);
  const toggleChecked = (event) => {
    setChecked((prev) => !prev);
    setOptionName((prev) => event.target.dataset.optionname);
  };
	
	// keep function reference.
  const optionHandler = useCallback(() => {
		let action = checked ? 'set' : 'unset';
		const dataService = new ReactApiService();
		dataService.post({endpoint:'optionsToTranslate',body:{name:optionName,action:action}})
			.then( 
				(response) => {
					setOptionName((prev) => false);
					afterSave({row:props.row, checked:checked, response:response});
				}
			)
  }, [checked,optionName,afterSave,props.row]) 	
	
	useEffect(() => {
		if ( false !== optionName ) {
			optionHandler();
		}
	  return () => {
			// console.log('return from useEffect content changed:: ');
	  }		
	}, [optionHandler,optionName]);

/**
	// with checking - mounted
	// keep function reference.
  const optionHandler = useCallback((optionName,mounted) => {
		console.log('optionName :: ', optionName );
		// let mounted = true;
		if ( optionName ) {
			
			let action = checked ? 'set' : 'unset';
			const dataService = new ReactApiService();
			dataService.post({endpoint:'optionsToTranslate',body:{name:optionName,action:action}})
				.then( 
					(response) => {
						if (mounted) {
							setOptionName((prev) => false);
							afterSave({row:props.row, checked:checked, response:response});
						}
					}
				)
			
		}
  }, [checked,afterSave,props.row]) 	
	
	useEffect(() => {
		// if ( false !== optionName ) {
			let mounted = true;
			optionHandler(optionName, mounted);
		// }
	  return () => {
			mounted = false;
			console.log('return from useEffect content changed:: unmounted');
	  }		
	}, [optionHandler,optionName]);
	
//*/	



  return (
    <FormGroup>
      <FormControlLabel
        control={
					<Switch 
						size="small" 
						checked={checked} 
						onChange={toggleChecked} 
						color="primary"
						inputProps={{name:'switcher-'+props.row.optionID, 'data-optionname':props.row.optionName, 'data-optionid':props.row.optionID}} 
						className={'switcher-wpglobus-root-primary-color'}
					/>
				}
        label=""
      />
    </FormGroup>
  );
}
